// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-order-main-wrap {
  margin-top: 42px;
}

.tracking-address-detail-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 378px;
  /* border: 2px solid #f8f8f8; */
  border-radius: 34px;
  padding: 30px;
  position: relative;
}

.tracking-address-detail-wrap h4 {
  font-size: 22px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.traking-detail-address-wrap .booking-detail-address {
  margin-top: 27px;
}

.tracking-selected-services {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.tracking-selected-services img {
  width: 70px;
}

.tracking-selected-services p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.traking-detail-address-wrap {
  margin-top: 28px;
}

.traking-detail-address-wrap h4 {
  font-size: 16px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.tranking-address-confrim-icon img {
  width: 70px;
}

.tranking-address-confrim-icon {
  position: absolute;
  right: 20px;
  top: 30px;
}

.contact-person-detail-wrap {
  width: 100%;
  /* height: 352px; */
  height: 326px;
  border: 2px solid #f8f8f8;
  border-radius: 34px;
  /* padding: 26px 40px; */
  padding: 34px 65px 34px 48px;
  margin-top: 20px;
  opacity: 0.6;
}

.contact-person-detail-wrap.active {
  opacity: 1;
}

.contact-person-booking-detail {
  opacity: 1;
}

.contact-person-lable h4 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.contact-person-lable {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-person-lable-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}

.contact-person-edit-wrap img {
  width: 34px;
  cursor: pointer;
}

.tracking-back-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tracking-back-wrap img {
  position: absolute;
  width: 24px;
  left: 20px;
  cursor: pointer;
}

.tracking-back-wrap h4 {
  font-size: 18px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.booking-id-tracking p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.home-tracking-service-detail-main-wrap {
  position: relative;
  border: 2px solid #f8f8f8;
  border-radius: 34px;
  /* min-height: 72vh; */
  /* height: 732px; */
  overflow: hidden;
  padding: 30px 50px;
  padding-right: 20px;
}

.traking-sercice-wrap {
  margin-top: 20px;
}

.traking-squirefeet-wrap {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.traking-sercice-wrap p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.traking-squirefeet-wrap span {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
}

.see-more-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  cursor: pointer;
}

.see-more-btn p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 500;
  margin: 0px;
}

.tranking-booking-cart-item {
  margin-top: 12px;
  text-align: right;
}

.booking-cart-items-wrap.tracking-cart-item-wrap {
  border-bottom: 1px dashed #e1e1e1;
  padding-bottom: 10px;
}

.rating-main-wrapper {
  display: flex;
  gap: 6px;
}

.order-track-status img {
  width: 35px;
}

.order-track-step {
  display: flex;
  height: 70px;
}

.cleaner-patner-step {
  height: 90px;
}

.order-track-long-step {
  height: 110px;
}

.order-track-step:last-child {
  /* overflow: hidden; */
  /* height: 340px; */
}

.order-track-step:last-child .order-track-status span:last-of-type {
  display: none;
}

.order-track-status {
  margin-right: 10px;
  position: relative;
  width: 30px;
}

.order-track-status-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00a19b;
  margin-left: 12px;
}

.order-track-status-line {
  display: block;
  margin: 0 auto;
  width: 0px;
  height: 90px;
  border-left: 1px dashed #e1e1e1;
  background: none;
}

.order-track-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-track-text h5 {
  font-size: 14px;
  font-weight: 600;
  color: #00a19b;
  margin: 0px;
}

p.order-text-schedul {
  font-size: 12px;
  font-weight: 400;
  color: #626262;
  margin: 0px;
}

.order-track-text-stat {
  font-size: 16px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.order-track-text-sub {
  font-size: 12px;
  color: #626262;
  font-weight: normal;
  margin: 0px;
  line-height: normal;
}

p.order-track-label {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
  margin-top: -6px;
}

.write-review-wrapper textarea {
  border: 1px solid #f3f3f3;
  border-radius: 13px;
  width: 404px;
  height: 160px;
  resize: none;
  padding: 20px;
  outline: none;
}

.write-review-wrapper textarea::placeholder {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
}

/*************** Rating css *****/
.rating-main-wrapper input {
  display: none;
}

.rating-main-wrapper svg {
  font-size: 50px;
}

.rating-main-wrapper svg {
  width: 22px;
  height: 41px;
  cursor: pointer;
}

img.order-step-complete-icon {
  margin-top: -10px;
}

/*******   Fix sidebar buttons chat and Share *****/
.right-sidebar-wrapper {
  /* right: -30px; */
  right: 0px;
  top: 40px;
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.sidebar-chat-wrap {
  width: 82px;
  height: 69px;
  background: #00a19b;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 0.4;
}

.sidebar-chat-wrap .active {
  opacity: 1;
}

.sidebar-chat-wrap img {
  width: 35px;
  margin-left: 30px;
  cursor: pointer;
}

.cancel-order-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.cancel-order-info p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.cancel-order-main-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  /* bottom: 140px; */
  bottom: 0px;
  left: 0;
  right: 0;
}

.order-track-long-step.order-completestep-wrap {
  position: absolute;
  background-color: #fff;
  /* bottom: 120px; */
  bottom: 230px;
  padding-top: 20px;
}

.cancel-order-info img {
  width: 14px;
  height: 14px;
}

.tracking-icon-for-tabs {
  display: none;
}

.tracking-back-btn {
  display: flex;
  align-items: center;
  gap: 10px;
}

.otp-number-wrap {
  position: relative;
  width: 151px;
  height: 45px;
  border-radius: 23px;
  background: #f3f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-left: 40px;
  /* margin-top: -60px;
    margin-bottom: 20px; */
}

.otp-number-wrap p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

.otp-number-wrap img {
  width: 15px;
  cursor: pointer;
}

.tracking-service-title-wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
}

span.copied-text {
  position: absolute;
  top: -20px;
  right: 0;
  color: #626262;
  font-size: 14px;
  font-weight: 500;
}

.readonly-info-wrap .booking-detail-address {
  margin-bottom: 28px;
}

.contact-person-detail-wrap {
  position: relative;
}

.contact-person-detail-wrap.active.contant-person-readonly-detail {
  padding: 90px 60px;
  position: relative;
}

.contact-person-edit-wrap {
  position: absolute;
  top: 26px;
  right: 26px;
}

.contact-person-lable img {
  cursor: pointer;
}

textarea.error-msg {
  border: 1px solid #ff0000;
}

textarea.error-msg::placeholder {
  color: #ff0000;
}

.write-review-wrapper p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.otp-guideline-info-icon img{
  width: 12px;
  position: absolute;
  right: -12px;
  top: -2px;
  cursor: pointer;
}

.mobile-otp-guideline-info-icon img{
  width: 10px;
  position: absolute;
  left: 20px;
  top: -9px;
}

.mobile-view-otp-wrap {
  position: relative;
}

.order-track-main-wrapper {
  /* height: 84vh; */
  overflow: auto;
  padding-bottom: 120px;
}

.contact-person-edit-wrap img:hover {
  scale: 0.9;
}


.service-main-image-wrapper img{
  /* width: 100%; */
    width: 280px;
    height: 280px;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
  .contact-person-detail-wrap {
    border-radius: 21px;
    /* padding: 20px 23px; */
    padding: 30px 20px 30px 20px;
    height: auto;
  }

  .contact-person-detail-wrap.active.contant-person-readonly-detail {
    padding: 40px;
    /* position: relative; */
    padding-bottom: 12px;
  }

  .home-tracking-service-detail-main-wrap {
    position: relative;
    margin-top: 30px;
    border: none;
    border-radius: 0px;
    min-height: unset;
    padding: 0px;
    margin-bottom: 100px;
  }

  .selected-service-detail-left {
    width: 100%;
    border-right: none;
    padding-right: 0px;
  }

  .traking-sercice-wrap {
    margin-top: 25px;
  }

  .traking-squirefeet-wrap {
    margin-top: 22px;
  }

  .booking-item-image {
    display: none;
  }

  .cleaning-precentage-item h6 {
    display: none;
  }

  .tracking-order-main-wrap {
    margin-top: 0px;
  }

  .otp-number-wrap {
    position: relative;
    width: unset;
    height: unset;
    border-radius: 23px;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-left: 20px;
  }

  .otp-number-wrap p {
    font-size: 14px;
    color: #00a19b;
    font-weight: 600;
    margin: 0px;
  }

  .otp-number-wrap img {
    width: 16px;
    cursor: pointer;
  }

.order-track-main-wrapper {
    height: auto;
    overflow: auto;
    padding-bottom: 10px;
}

.trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {
  padding-right: 0px ;
}

.order-track-status-line {
  display: block;
  margin: 0 auto;
  width: 0px;
  height: 60px;
}

.order-track-long-step .order-track-status-line {
  display: block;
  margin: 0 auto;
  width: 0px;
  height: 100px;
}

.order-track-status-dot {
  margin-left: 10px;
}

.order-track-status img {
  width: 30px;
  margin-left: -2px;
}


.order-track-step:last-child {
  /* overflow: hidden; */
  height: 340px;
}

.tracking-back-wrap img {
  display: none;
}

}

@media (max-width: 390px) {
}

@media (max-width: 360px) {
}

@media (max-width: 330px) {
}

@media (min-width: 768px) and (max-width: 1024px) {
  /* .tracking-address-detail-wrap {
        height: 300px;
        border-radius: 24px;
        padding: 26px 16px;
    }

    .tracking-address-detail-wrap h4 {
        font-size: 16px;
    }

    .tracking-selected-services {
        margin-top: 10px;
    }

    .tracking-selected-services p {
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
    }

    .traking-detail-address-wrap {
        margin-top: 36px;
    }

    .tracking-selected-services img {
        width: 34px;
    }

    .tranking-address-confrim-icon {
        right: 10px;
        top: 10px;
    }

    .tranking-address-confrim-icon img {
        display: none;
    }

    .contact-person-detail-wrap {
        border-radius: 24px;
        padding: 26px 16px;
    }

    .contact-person-edit-wrap img {
        width: 30px;
    }

    .tracking-back-wrap h4 {
        font-size: 16px;
    }

    .home-tracking-service-detail-main-wrap {
        border-radius: 24px;
        padding: 30px 30px;
    }

    .home-tracking-service-detail-main-wrap .tracking-back-wrap {
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .home-tracking-service-detail-main-wrap .tracking-item-count {
        margin-left: 20px;
    }

    .home-tracking-service-detail-main-wrap .selected-service-detail-left {
        padding-right: 10px;
    }

    .home-tracking-service-detail-main-wrap .selected-service-detail-wrap {
        grid-template-columns: 100%;
        gap: 6px;
    }

    .right-sidebar-wrapper {
        right: -25px;
    }

    .sidebar-chat-wrap {
        width: 66px;
        height: 62px;
    }

    .sidebar-chat-wrap img {
        width: 32px;
        margin-left: 20px;
    }

    .order-cance-btn {
        width: 100%;
    }

    button.cancel-order-button {
        width: 100%;
    }

    .cancel-order-info {
        align-items: baseline;
        gap: 5px;
    }

    .cancel-order-main-wrap {
        left: 40px;
        right: 30px;
        bottom: 40px;
      }

    .booking-item-detail.cleaning-precentage-item h6 {
        display: none;
    }

    .booking-cart-items-wrap.tracking-cart-item-wrap .booking-cart-item-repeat {
        flex-direction: row;
        margin-bottom: 16px;
    }

    .booking-cart-items-wrap.tracking-cart-item-wrap .booking-item-detail span {
        display: none;
    }

    .home-service-detail-main-wrap .selected-service-detail-right {
        padding-right: 10px;
    }

    .booking-item-detail.cleaning-precentage-item span {
        display: block !important;
    }

    .tracking-icon-for-tabs {
        display: block;
        display: flex;
        align-items: center;
        gap: 0px;
    }

    .tracking-icon-for-tabs img {
        width: 40px;
        cursor: pointer;
    }

    .tracking-icon-for-tabs p {
        font-size: 14px;
        margin: 0px;
        color: #00A19B;
        font-weight: 500;
    }

    .tracking-back-btn {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .track-order-tabs-none {
        display: none;
    } */

  .tracking-order-main-wrap .col-lg-4 {
    width: 100%;
  }

  .tracking-order-main-wrap .col-lg-8 {
    width: 100%;
  }
}

@media (min-width: 1025px) and (max-width: 1599px) {
  .tracking-address-detail-wrap {
    height: 258px;
    border-radius: 24px;
    /* padding: 18px 20px; */
    padding: 20px;
  }

  .tracking-address-detail-wrap h4 {
    font-size: 14px;
    font-weight: 700;
  }

  .tracking-selected-services img {
    width: 60px;
  }

  .tranking-address-confrim-icon {
    right: 10px;
    top: 10px;
  }

  .tranking-address-confrim-icon img {
    width: 38px;
  }

  .tracking-selected-services p {
    font-size: 12px;
  }

  .tracking-selected-services {
    margin-top: 10px;
  }

  .traking-detail-address-wrap {
    margin-top: 12px;
  }

  .traking-detail-address-wrap .booking-detail-address {
    margin-top: 13px;
  }

  .traking-detail-address-wrap h4 {
    font-size: 12px;
  }

  .contact-person-detail-wrap {
    border-radius: 24px;
    padding: 26px 50px 26px 32px;
    height: 247px;
  }

  .contact-person-edit-wrap {
    position: absolute;
    top: 18px;
    right: 18px;
  }

  .contact-person-lable h4 {
    font-size: 12px;
  }

  .contact-person-detail-wrap .field {
    margin-bottom: 12px;
  }

  .contact-person-lable-wrap {
    margin-bottom: 14px;
  }

  .contact-person-edit-wrap img {
    width: 26px;
  }

  .tracking-back-wrap h4 {
    font-size: 14px;
  }

  .tracking-back-wrap img {
    width: 20px;
    /* margin-left: -50px; */
  }

  .booking-id-tracking p {
    font-size: 12px;
  }

  .traking-sercice-wrap p {
    font-size: 12px;
  }

  .traking-squirefeet-wrap span {
    font-size: 12px;
  }

  .traking-squirefeet-wrap {
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .traking-sercice-wrap {
    margin-top: 14px;
  }

  .home-tracking-service-detail-main-wrap {
    border-radius: 24px;
    padding: 18px 30px;
    height: 525px;
    padding-right: 5px;
  }

  /* .order-track-main-wrapper {
    height: 88vh;
    height: 600px;
    overflow: auto;
    padding-bottom: 10px;
} */

  .order-track-scroll-wrap{
    /* height: 576px; */
    height: 290px;
    padding-bottom: 40px;
    overflow: auto;
  }

  .order-track-long-step.order-completestep-wrap {
    padding-right: 20px;
    bottom: 165px;
  }
  

  .home-tracking-service-detail-main-wrap .tracking-back-wrap {
    margin-left: 20px;
  }

  .home-tracking-service-detail-main-wrap .tracking-item-count {
    margin-left: 0px;
  }

  .home-tracking-service-detail-main-wrap .selected-service-detail-left {
    padding-right: 10px;
    height: 490px;
    overflow: auto;
  }

  .home-tracking-service-detail-main-wrap .selected-service-detail-wrap {
    grid-template-columns: 55% 45%;
    gap: 6px;
  }

  .right-sidebar-wrapper {
    /* right: -25px; */
  }

  .sidebar-chat-wrap {
    width: 66px;
    height: 62px;
  }

  .sidebar-chat-wrap img {
    width: 32px;
    margin-left: 20px;
  }

  .order-cance-btn {
    width: 100%;
  }

  button.cancel-order-button {
    width: 100%;
  }

  .cancel-order-info {
    align-items: baseline;
    gap: 5px;
  }

  .cancel-order-main-wrap {
    left: 10px;
    right: 20px;
    /* bottom: 120px; */
    bottom: 0px;
    gap: 10px;
  }

  .booking-item-detail.cleaning-precentage-item h6 {
    display: none;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap .booking-cart-item-repeat {
    flex-direction: row;
    margin-bottom: 14px;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap .booking-item-detail span {
    display: none;
  }

  .home-service-detail-main-wrap .selected-service-detail-right {
    /* padding-right: 10px; */
    /* height: 480px;
        overflow: auto; */
  }

  .service-items-main-wrap.extra-service-item-wrap {
    margin-top: 0px !important;
    height: 330px;
    overflow: auto;
    padding-right: 10px;
  }

  .booking-item-detail.cleaning-precentage-item span {
    display: block !important;
  }

  .otp-number-wrap p {
    font-size: 12px;
  }

  .otp-number-wrap {
    position: relative;
    width: 132px;
    height: 33px;
  }

  .otp-number-wrap img {
    width: 12px;
    cursor: pointer;
  }

  .tracking-order-main-wrap {
    margin-top: 20px;
  }

  .booking-item-image {
    width: 18px;
    height: 18px;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap
    .booking-cart-item-right-wrapper {
    width: unset;
  }

  .tracking-cart-item-wrap .booking-item-detail.cleaning-precentage-item h6 {
    display: block;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap {
    margin-top: 11px;
    padding-bottom: 8px;
  }

  .see-more-btn {
    margin-top: -8px;
  }

  .see-more-btn p {
    font-size: 12px;
  }

  .see-more-btn img {
    width: 5px;
    height: 9px;
  }

  .order-track-text-stat {
    font-size: 14px;
  }

  .order-track-step {
    display: flex;
    height: 56px;
  }

  .cleaner-patner-step {
    height: 66px;
  }

  .order-track-long-step {
    height: 90px;
  }

  .order-track-text h5 {
    font-size: 12px;
  }

  .order-track-text-sub {
    white-space: nowrap;
  }

  p.order-track-label {
    font-size: 12px;
    line-height: normal;
    margin-top: -4px;
  }

  .order-track-status {
    width: 20px;
  }

  .order-track-status img {
    width: 28px;
    margin-left: -4px;
  }

  .order-track-status-dot {
    margin-left: 6px;
  }

  .write-review-wrapper textarea {
    border: 1px solid #f3f3f3;
    border-radius: 13px;
    width: 280px;
    height: 96px;
    padding: 10px;
  }

  .order-track-main-wrapper .book-button-wrapper {
    margin-top: 0px;
  }

  .cancel-order-info p {
    font-size: 12px;
  }

  .cancel-order-info img {
    width: 12px;
    height: 10px;
    margin-top: 2px;
  }

  .contact-person-detail-wrap.active.contant-person-readonly-detail {
    padding: 57px 42px;
    position: relative;
  }

  .service-main-image-wrapper img{
    width: 180px;
    height: 180px;
}
}

@media (min-width: 1025px) and (max-width: 1199px) {

  .tracking-address-detail-wrap {
    padding: 0px;
    padding-top: 20px;
  }

  .tracking-cart-item-wrap .booking-item-detail.cleaning-precentage-item h6 {
    display: none;
  }

  .tracking-selected-services img {
    display: none;
  }

  .traking-detail-address-wrap {
    margin-top: 50px;
  }

  .order-track-text-sub {
    white-space: normal;
  }

  .write-review-wrapper textarea {
    width: 230px;
  }

  .order-track-status {
    width: 12px;
  }

  .order-track-status img {
    width: 30px;
    margin-left: -9px;
  }

  .order-track-status-dot {
    margin-left: 2px;
  }

  .order-track-long-step {
    height: 100px;
  }

  .order-track-status img {
    width: 20px;
    margin-left: -2px;
  }

  .cancel-order-main-wrap {
    bottom: 10px;
  }
}

@media (min-width: 1600px) {
  .home-tracking-service-detail-main-wrap {
    height: 724px !important;
  }

  .order-track-scroll-wrap{
    /* height: 660px; */
    height: 480px;
        /* padding-bottom: 50px; */
    padding-bottom: 130px;
    overflow: auto;
  }

  .order-track-long-step.order-completestep-wrap {
    padding-right: 100px;
    height: 240px;
    bottom: 100px;
  }
  

}


`, "",{"version":3,"sources":["webpack://./src/components/dashboard/trackingorder.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB;0BACwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,iBAAiB;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;AAEF;IACI,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;;AAGA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA6JK;;EAEL;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;;;;;GAKC;;EAED;IACE,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB;yBACqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;AACjB;AACA;;AAEA;;EAEE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,aAAa;QACT,0BAA0B;IAC9B,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,aAAa;EACf;;;AAGF","sourcesContent":[".tracking-order-main-wrap {\r\n  margin-top: 42px;\r\n}\r\n\r\n.tracking-address-detail-wrap {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 378px;\r\n  /* border: 2px solid #f8f8f8; */\r\n  border-radius: 34px;\r\n  padding: 30px;\r\n  position: relative;\r\n}\r\n\r\n.tracking-address-detail-wrap h4 {\r\n  font-size: 22px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.traking-detail-address-wrap .booking-detail-address {\r\n  margin-top: 27px;\r\n}\r\n\r\n.tracking-selected-services {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 20px;\r\n  gap: 10px;\r\n}\r\n\r\n.tracking-selected-services img {\r\n  width: 70px;\r\n}\r\n\r\n.tracking-selected-services p {\r\n  font-size: 14px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.traking-detail-address-wrap {\r\n  margin-top: 28px;\r\n}\r\n\r\n.traking-detail-address-wrap h4 {\r\n  font-size: 16px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.tranking-address-confrim-icon img {\r\n  width: 70px;\r\n}\r\n\r\n.tranking-address-confrim-icon {\r\n  position: absolute;\r\n  right: 20px;\r\n  top: 30px;\r\n}\r\n\r\n.contact-person-detail-wrap {\r\n  width: 100%;\r\n  /* height: 352px; */\r\n  height: 326px;\r\n  border: 2px solid #f8f8f8;\r\n  border-radius: 34px;\r\n  /* padding: 26px 40px; */\r\n  padding: 34px 65px 34px 48px;\r\n  margin-top: 20px;\r\n  opacity: 0.6;\r\n}\r\n\r\n.contact-person-detail-wrap.active {\r\n  opacity: 1;\r\n}\r\n\r\n.contact-person-booking-detail {\r\n  opacity: 1;\r\n}\r\n\r\n.contact-person-lable h4 {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.contact-person-lable {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.contact-person-lable-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.contact-person-edit-wrap img {\r\n  width: 34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tracking-back-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.tracking-back-wrap img {\r\n  position: absolute;\r\n  width: 24px;\r\n  left: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tracking-back-wrap h4 {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: bold;\r\n  margin: 0px;\r\n}\r\n\r\n.booking-id-tracking p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.home-tracking-service-detail-main-wrap {\r\n  position: relative;\r\n  border: 2px solid #f8f8f8;\r\n  border-radius: 34px;\r\n  /* min-height: 72vh; */\r\n  /* height: 732px; */\r\n  overflow: hidden;\r\n  padding: 30px 50px;\r\n  padding-right: 20px;\r\n}\r\n\r\n.traking-sercice-wrap {\r\n  margin-top: 20px;\r\n}\r\n\r\n.traking-squirefeet-wrap {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.traking-sercice-wrap p {\r\n  font-size: 14px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.traking-squirefeet-wrap span {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 500;\r\n}\r\n\r\n.see-more-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.see-more-btn p {\r\n  font-size: 14px;\r\n  color: #00a19b;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n}\r\n\r\n.tranking-booking-cart-item {\r\n  margin-top: 12px;\r\n  text-align: right;\r\n}\r\n\r\n.booking-cart-items-wrap.tracking-cart-item-wrap {\r\n  border-bottom: 1px dashed #e1e1e1;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.rating-main-wrapper {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.order-track-status img {\r\n  width: 35px;\r\n}\r\n\r\n.order-track-step {\r\n  display: flex;\r\n  height: 70px;\r\n}\r\n\r\n.cleaner-patner-step {\r\n  height: 90px;\r\n}\r\n\r\n.order-track-long-step {\r\n  height: 110px;\r\n}\r\n\r\n.order-track-step:last-child {\r\n  /* overflow: hidden; */\r\n  /* height: 340px; */\r\n}\r\n\r\n.order-track-step:last-child .order-track-status span:last-of-type {\r\n  display: none;\r\n}\r\n\r\n.order-track-status {\r\n  margin-right: 10px;\r\n  position: relative;\r\n  width: 30px;\r\n}\r\n\r\n.order-track-status-dot {\r\n  display: block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #00a19b;\r\n  margin-left: 12px;\r\n}\r\n\r\n.order-track-status-line {\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 0px;\r\n  height: 90px;\r\n  border-left: 1px dashed #e1e1e1;\r\n  background: none;\r\n}\r\n\r\n.order-track-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.order-track-text h5 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #00a19b;\r\n  margin: 0px;\r\n}\r\n\r\np.order-text-schedul {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: #626262;\r\n  margin: 0px;\r\n}\r\n\r\n.order-track-text-stat {\r\n  font-size: 16px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.order-track-text-sub {\r\n  font-size: 12px;\r\n  color: #626262;\r\n  font-weight: normal;\r\n  margin: 0px;\r\n  line-height: normal;\r\n}\r\n\r\np.order-track-label {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 500;\r\n  margin: 0px;\r\n  margin-top: -6px;\r\n}\r\n\r\n.write-review-wrapper textarea {\r\n  border: 1px solid #f3f3f3;\r\n  border-radius: 13px;\r\n  width: 404px;\r\n  height: 160px;\r\n  resize: none;\r\n  padding: 20px;\r\n  outline: none;\r\n}\r\n\r\n.write-review-wrapper textarea::placeholder {\r\n  font-size: 12px;\r\n  color: #626262;\r\n  font-weight: 400;\r\n}\r\n\r\n/*************** Rating css *****/\r\n.rating-main-wrapper input {\r\n  display: none;\r\n}\r\n\r\n.rating-main-wrapper svg {\r\n  font-size: 50px;\r\n}\r\n\r\n.rating-main-wrapper svg {\r\n  width: 22px;\r\n  height: 41px;\r\n  cursor: pointer;\r\n}\r\n\r\nimg.order-step-complete-icon {\r\n  margin-top: -10px;\r\n}\r\n\r\n/*******   Fix sidebar buttons chat and Share *****/\r\n.right-sidebar-wrapper {\r\n  /* right: -30px; */\r\n  right: 0px;\r\n  top: 40px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.sidebar-chat-wrap {\r\n  width: 82px;\r\n  height: 69px;\r\n  background: #00a19b;\r\n  border-top-left-radius: 80px;\r\n  border-bottom-left-radius: 80px;\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  opacity: 0.4;\r\n}\r\n\r\n.sidebar-chat-wrap .active {\r\n  opacity: 1;\r\n}\r\n\r\n.sidebar-chat-wrap img {\r\n  width: 35px;\r\n  margin-left: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cancel-order-info {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n.cancel-order-info p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.cancel-order-main-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  position: absolute;\r\n  /* bottom: 140px; */\r\n  bottom: 0px;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.order-track-long-step.order-completestep-wrap {\r\n  position: absolute;\r\n  background-color: #fff;\r\n  /* bottom: 120px; */\r\n  bottom: 230px;\r\n  padding-top: 20px;\r\n}\r\n\r\n.cancel-order-info img {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.tracking-icon-for-tabs {\r\n  display: none;\r\n}\r\n\r\n.tracking-back-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.otp-number-wrap {\r\n  position: relative;\r\n  width: 151px;\r\n  height: 45px;\r\n  border-radius: 23px;\r\n  background: #f3f3f3;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-left: 40px;\r\n  /* margin-top: -60px;\r\n    margin-bottom: 20px; */\r\n}\r\n\r\n.otp-number-wrap p {\r\n  font-size: 14px;\r\n  color: #00a19b;\r\n  font-weight: 600;\r\n  margin: 0px;\r\n}\r\n\r\n.otp-number-wrap img {\r\n  width: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tracking-service-title-wrap {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\nspan.copied-text {\r\n  position: absolute;\r\n  top: -20px;\r\n  right: 0;\r\n  color: #626262;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.readonly-info-wrap .booking-detail-address {\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.contact-person-detail-wrap {\r\n  position: relative;\r\n}\r\n\r\n.contact-person-detail-wrap.active.contant-person-readonly-detail {\r\n  padding: 90px 60px;\r\n  position: relative;\r\n}\r\n\r\n.contact-person-edit-wrap {\r\n  position: absolute;\r\n  top: 26px;\r\n  right: 26px;\r\n}\r\n\r\n.contact-person-lable img {\r\n  cursor: pointer;\r\n}\r\n\r\ntextarea.error-msg {\r\n  border: 1px solid #ff0000;\r\n}\r\n\r\ntextarea.error-msg::placeholder {\r\n  color: #ff0000;\r\n}\r\n\r\n.write-review-wrapper p {\r\n  font-size: 14px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.otp-guideline-info-icon img{\r\n  width: 12px;\r\n  position: absolute;\r\n  right: -12px;\r\n  top: -2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-otp-guideline-info-icon img{\r\n  width: 10px;\r\n  position: absolute;\r\n  left: 20px;\r\n  top: -9px;\r\n}\r\n\r\n.mobile-view-otp-wrap {\r\n  position: relative;\r\n}\r\n\r\n.order-track-main-wrapper {\r\n  /* height: 84vh; */\r\n  overflow: auto;\r\n  padding-bottom: 120px;\r\n}\r\n\r\n.contact-person-edit-wrap img:hover {\r\n  scale: 0.9;\r\n}\r\n\r\n\r\n.service-main-image-wrapper img{\r\n  /* width: 100%; */\r\n    width: 280px;\r\n    height: 280px;\r\n}\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 1024px) {\r\n  .contact-person-detail-wrap {\r\n    border-radius: 21px;\r\n    /* padding: 20px 23px; */\r\n    padding: 30px 20px 30px 20px;\r\n    height: auto;\r\n  }\r\n\r\n  .contact-person-detail-wrap.active.contant-person-readonly-detail {\r\n    padding: 40px;\r\n    /* position: relative; */\r\n    padding-bottom: 12px;\r\n  }\r\n\r\n  .home-tracking-service-detail-main-wrap {\r\n    position: relative;\r\n    margin-top: 30px;\r\n    border: none;\r\n    border-radius: 0px;\r\n    min-height: unset;\r\n    padding: 0px;\r\n    margin-bottom: 100px;\r\n  }\r\n\r\n  .selected-service-detail-left {\r\n    width: 100%;\r\n    border-right: none;\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .traking-sercice-wrap {\r\n    margin-top: 25px;\r\n  }\r\n\r\n  .traking-squirefeet-wrap {\r\n    margin-top: 22px;\r\n  }\r\n\r\n  .booking-item-image {\r\n    display: none;\r\n  }\r\n\r\n  .cleaning-precentage-item h6 {\r\n    display: none;\r\n  }\r\n\r\n  .tracking-order-main-wrap {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .otp-number-wrap {\r\n    position: relative;\r\n    width: unset;\r\n    height: unset;\r\n    border-radius: 23px;\r\n    background: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .otp-number-wrap p {\r\n    font-size: 14px;\r\n    color: #00a19b;\r\n    font-weight: 600;\r\n    margin: 0px;\r\n  }\r\n\r\n  .otp-number-wrap img {\r\n    width: 16px;\r\n    cursor: pointer;\r\n  }\r\n\r\n.order-track-main-wrapper {\r\n    height: auto;\r\n    overflow: auto;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.trackorder-offcanvas-wrapper.offcanvas.offcanvas-end.show {\r\n  padding-right: 0px ;\r\n}\r\n\r\n.order-track-status-line {\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 0px;\r\n  height: 60px;\r\n}\r\n\r\n.order-track-long-step .order-track-status-line {\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 0px;\r\n  height: 100px;\r\n}\r\n\r\n.order-track-status-dot {\r\n  margin-left: 10px;\r\n}\r\n\r\n.order-track-status img {\r\n  width: 30px;\r\n  margin-left: -2px;\r\n}\r\n\r\n\r\n.order-track-step:last-child {\r\n  /* overflow: hidden; */\r\n  height: 340px;\r\n}\r\n\r\n.tracking-back-wrap img {\r\n  display: none;\r\n}\r\n\r\n}\r\n\r\n@media (max-width: 390px) {\r\n}\r\n\r\n@media (max-width: 360px) {\r\n}\r\n\r\n@media (max-width: 330px) {\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  /* .tracking-address-detail-wrap {\r\n        height: 300px;\r\n        border-radius: 24px;\r\n        padding: 26px 16px;\r\n    }\r\n\r\n    .tracking-address-detail-wrap h4 {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .tracking-selected-services {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .tracking-selected-services p {\r\n        text-overflow: ellipsis;\r\n        width: 100%;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .traking-detail-address-wrap {\r\n        margin-top: 36px;\r\n    }\r\n\r\n    .tracking-selected-services img {\r\n        width: 34px;\r\n    }\r\n\r\n    .tranking-address-confrim-icon {\r\n        right: 10px;\r\n        top: 10px;\r\n    }\r\n\r\n    .tranking-address-confrim-icon img {\r\n        display: none;\r\n    }\r\n\r\n    .contact-person-detail-wrap {\r\n        border-radius: 24px;\r\n        padding: 26px 16px;\r\n    }\r\n\r\n    .contact-person-edit-wrap img {\r\n        width: 30px;\r\n    }\r\n\r\n    .tracking-back-wrap h4 {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .home-tracking-service-detail-main-wrap {\r\n        border-radius: 24px;\r\n        padding: 30px 30px;\r\n    }\r\n\r\n    .home-tracking-service-detail-main-wrap .tracking-back-wrap {\r\n        margin-left: 20px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .home-tracking-service-detail-main-wrap .tracking-item-count {\r\n        margin-left: 20px;\r\n    }\r\n\r\n    .home-tracking-service-detail-main-wrap .selected-service-detail-left {\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .home-tracking-service-detail-main-wrap .selected-service-detail-wrap {\r\n        grid-template-columns: 100%;\r\n        gap: 6px;\r\n    }\r\n\r\n    .right-sidebar-wrapper {\r\n        right: -25px;\r\n    }\r\n\r\n    .sidebar-chat-wrap {\r\n        width: 66px;\r\n        height: 62px;\r\n    }\r\n\r\n    .sidebar-chat-wrap img {\r\n        width: 32px;\r\n        margin-left: 20px;\r\n    }\r\n\r\n    .order-cance-btn {\r\n        width: 100%;\r\n    }\r\n\r\n    button.cancel-order-button {\r\n        width: 100%;\r\n    }\r\n\r\n    .cancel-order-info {\r\n        align-items: baseline;\r\n        gap: 5px;\r\n    }\r\n\r\n    .cancel-order-main-wrap {\r\n        left: 40px;\r\n        right: 30px;\r\n        bottom: 40px;\r\n      }\r\n\r\n    .booking-item-detail.cleaning-precentage-item h6 {\r\n        display: none;\r\n    }\r\n\r\n    .booking-cart-items-wrap.tracking-cart-item-wrap .booking-cart-item-repeat {\r\n        flex-direction: row;\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    .booking-cart-items-wrap.tracking-cart-item-wrap .booking-item-detail span {\r\n        display: none;\r\n    }\r\n\r\n    .home-service-detail-main-wrap .selected-service-detail-right {\r\n        padding-right: 10px;\r\n    }\r\n\r\n    .booking-item-detail.cleaning-precentage-item span {\r\n        display: block !important;\r\n    }\r\n\r\n    .tracking-icon-for-tabs {\r\n        display: block;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0px;\r\n    }\r\n\r\n    .tracking-icon-for-tabs img {\r\n        width: 40px;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .tracking-icon-for-tabs p {\r\n        font-size: 14px;\r\n        margin: 0px;\r\n        color: #00A19B;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .tracking-back-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n    }\r\n\r\n    .track-order-tabs-none {\r\n        display: none;\r\n    } */\r\n\r\n  .tracking-order-main-wrap .col-lg-4 {\r\n    width: 100%;\r\n  }\r\n\r\n  .tracking-order-main-wrap .col-lg-8 {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1599px) {\r\n  .tracking-address-detail-wrap {\r\n    height: 258px;\r\n    border-radius: 24px;\r\n    /* padding: 18px 20px; */\r\n    padding: 20px;\r\n  }\r\n\r\n  .tracking-address-detail-wrap h4 {\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .tracking-selected-services img {\r\n    width: 60px;\r\n  }\r\n\r\n  .tranking-address-confrim-icon {\r\n    right: 10px;\r\n    top: 10px;\r\n  }\r\n\r\n  .tranking-address-confrim-icon img {\r\n    width: 38px;\r\n  }\r\n\r\n  .tracking-selected-services p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .tracking-selected-services {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .traking-detail-address-wrap {\r\n    margin-top: 12px;\r\n  }\r\n\r\n  .traking-detail-address-wrap .booking-detail-address {\r\n    margin-top: 13px;\r\n  }\r\n\r\n  .traking-detail-address-wrap h4 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .contact-person-detail-wrap {\r\n    border-radius: 24px;\r\n    padding: 26px 50px 26px 32px;\r\n    height: 247px;\r\n  }\r\n\r\n  .contact-person-edit-wrap {\r\n    position: absolute;\r\n    top: 18px;\r\n    right: 18px;\r\n  }\r\n\r\n  .contact-person-lable h4 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .contact-person-detail-wrap .field {\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .contact-person-lable-wrap {\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  .contact-person-edit-wrap img {\r\n    width: 26px;\r\n  }\r\n\r\n  .tracking-back-wrap h4 {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .tracking-back-wrap img {\r\n    width: 20px;\r\n    /* margin-left: -50px; */\r\n  }\r\n\r\n  .booking-id-tracking p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .traking-sercice-wrap p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .traking-squirefeet-wrap span {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .traking-squirefeet-wrap {\r\n    margin-top: 14px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .traking-sercice-wrap {\r\n    margin-top: 14px;\r\n  }\r\n\r\n  .home-tracking-service-detail-main-wrap {\r\n    border-radius: 24px;\r\n    padding: 18px 30px;\r\n    height: 525px;\r\n    padding-right: 5px;\r\n  }\r\n\r\n  /* .order-track-main-wrapper {\r\n    height: 88vh;\r\n    height: 600px;\r\n    overflow: auto;\r\n    padding-bottom: 10px;\r\n} */\r\n\r\n  .order-track-scroll-wrap{\r\n    /* height: 576px; */\r\n    height: 290px;\r\n    padding-bottom: 40px;\r\n    overflow: auto;\r\n  }\r\n\r\n  .order-track-long-step.order-completestep-wrap {\r\n    padding-right: 20px;\r\n    bottom: 165px;\r\n  }\r\n  \r\n\r\n  .home-tracking-service-detail-main-wrap .tracking-back-wrap {\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .home-tracking-service-detail-main-wrap .tracking-item-count {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .home-tracking-service-detail-main-wrap .selected-service-detail-left {\r\n    padding-right: 10px;\r\n    height: 490px;\r\n    overflow: auto;\r\n  }\r\n\r\n  .home-tracking-service-detail-main-wrap .selected-service-detail-wrap {\r\n    grid-template-columns: 55% 45%;\r\n    gap: 6px;\r\n  }\r\n\r\n  .right-sidebar-wrapper {\r\n    /* right: -25px; */\r\n  }\r\n\r\n  .sidebar-chat-wrap {\r\n    width: 66px;\r\n    height: 62px;\r\n  }\r\n\r\n  .sidebar-chat-wrap img {\r\n    width: 32px;\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .order-cance-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  button.cancel-order-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .cancel-order-info {\r\n    align-items: baseline;\r\n    gap: 5px;\r\n  }\r\n\r\n  .cancel-order-main-wrap {\r\n    left: 10px;\r\n    right: 20px;\r\n    /* bottom: 120px; */\r\n    bottom: 0px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .booking-item-detail.cleaning-precentage-item h6 {\r\n    display: none;\r\n  }\r\n\r\n  .booking-cart-items-wrap.tracking-cart-item-wrap .booking-cart-item-repeat {\r\n    flex-direction: row;\r\n    margin-bottom: 14px;\r\n  }\r\n\r\n  .booking-cart-items-wrap.tracking-cart-item-wrap .booking-item-detail span {\r\n    display: none;\r\n  }\r\n\r\n  .home-service-detail-main-wrap .selected-service-detail-right {\r\n    /* padding-right: 10px; */\r\n    /* height: 480px;\r\n        overflow: auto; */\r\n  }\r\n\r\n  .service-items-main-wrap.extra-service-item-wrap {\r\n    margin-top: 0px !important;\r\n    height: 330px;\r\n    overflow: auto;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .booking-item-detail.cleaning-precentage-item span {\r\n    display: block !important;\r\n  }\r\n\r\n  .otp-number-wrap p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .otp-number-wrap {\r\n    position: relative;\r\n    width: 132px;\r\n    height: 33px;\r\n  }\r\n\r\n  .otp-number-wrap img {\r\n    width: 12px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .tracking-order-main-wrap {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .booking-item-image {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n\r\n  .booking-cart-items-wrap.tracking-cart-item-wrap\r\n    .booking-cart-item-right-wrapper {\r\n    width: unset;\r\n  }\r\n\r\n  .tracking-cart-item-wrap .booking-item-detail.cleaning-precentage-item h6 {\r\n    display: block;\r\n  }\r\n\r\n  .booking-cart-items-wrap.tracking-cart-item-wrap {\r\n    margin-top: 11px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  .see-more-btn {\r\n    margin-top: -8px;\r\n  }\r\n\r\n  .see-more-btn p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .see-more-btn img {\r\n    width: 5px;\r\n    height: 9px;\r\n  }\r\n\r\n  .order-track-text-stat {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .order-track-step {\r\n    display: flex;\r\n    height: 56px;\r\n  }\r\n\r\n  .cleaner-patner-step {\r\n    height: 66px;\r\n  }\r\n\r\n  .order-track-long-step {\r\n    height: 90px;\r\n  }\r\n\r\n  .order-track-text h5 {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .order-track-text-sub {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  p.order-track-label {\r\n    font-size: 12px;\r\n    line-height: normal;\r\n    margin-top: -4px;\r\n  }\r\n\r\n  .order-track-status {\r\n    width: 20px;\r\n  }\r\n\r\n  .order-track-status img {\r\n    width: 28px;\r\n    margin-left: -4px;\r\n  }\r\n\r\n  .order-track-status-dot {\r\n    margin-left: 6px;\r\n  }\r\n\r\n  .write-review-wrapper textarea {\r\n    border: 1px solid #f3f3f3;\r\n    border-radius: 13px;\r\n    width: 280px;\r\n    height: 96px;\r\n    padding: 10px;\r\n  }\r\n\r\n  .order-track-main-wrapper .book-button-wrapper {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .cancel-order-info p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .cancel-order-info img {\r\n    width: 12px;\r\n    height: 10px;\r\n    margin-top: 2px;\r\n  }\r\n\r\n  .contact-person-detail-wrap.active.contant-person-readonly-detail {\r\n    padding: 57px 42px;\r\n    position: relative;\r\n  }\r\n\r\n  .service-main-image-wrapper img{\r\n    width: 180px;\r\n    height: 180px;\r\n}\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n\r\n  .tracking-address-detail-wrap {\r\n    padding: 0px;\r\n    padding-top: 20px;\r\n  }\r\n\r\n  .tracking-cart-item-wrap .booking-item-detail.cleaning-precentage-item h6 {\r\n    display: none;\r\n  }\r\n\r\n  .tracking-selected-services img {\r\n    display: none;\r\n  }\r\n\r\n  .traking-detail-address-wrap {\r\n    margin-top: 50px;\r\n  }\r\n\r\n  .order-track-text-sub {\r\n    white-space: normal;\r\n  }\r\n\r\n  .write-review-wrapper textarea {\r\n    width: 230px;\r\n  }\r\n\r\n  .order-track-status {\r\n    width: 12px;\r\n  }\r\n\r\n  .order-track-status img {\r\n    width: 30px;\r\n    margin-left: -9px;\r\n  }\r\n\r\n  .order-track-status-dot {\r\n    margin-left: 2px;\r\n  }\r\n\r\n  .order-track-long-step {\r\n    height: 100px;\r\n  }\r\n\r\n  .order-track-status img {\r\n    width: 20px;\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .cancel-order-main-wrap {\r\n    bottom: 10px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .home-tracking-service-detail-main-wrap {\r\n    height: 724px !important;\r\n  }\r\n\r\n  .order-track-scroll-wrap{\r\n    /* height: 660px; */\r\n    height: 480px;\r\n        /* padding-bottom: 50px; */\r\n    padding-bottom: 130px;\r\n    overflow: auto;\r\n  }\r\n\r\n  .order-track-long-step.order-completestep-wrap {\r\n    padding-right: 100px;\r\n    height: 240px;\r\n    bottom: 100px;\r\n  }\r\n  \r\n\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
